export { default } from '@/modules/ouvidoria/pages/identificacao/index'
